export default __webpack_public_path__ + "static/media/partner-dresden.dc2673fd.jpg";